// extracted by mini-css-extract-plugin
module.exports = {"meal":"Meal_meal__fK6UM","available":"Meal_available__gB6bx","unavailable":"Meal_unavailable__3tlet"};